import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';
import { PortfolioSiteExplorerUIState } from './portfolioSiteExplorerSlice';

// Base selector
export const getPortfolioSiteExplorerState = (state: RootState): PortfolioSiteExplorerUIState => {
    return (
        state.portfolio?.portfolioSiteExplorer || {
            isSidebarOpen: true,
            selectedMetric: 'NA',
            hoveredSiteId: null,
            selectedSiteId: null,
            mapZoom: 2,
            mapCenter: [20, 0],
        }
    );
};

// Derived selectors
export const getIsSidebarOpen = createSelector(
    [getPortfolioSiteExplorerState],
    portfolioSiteExplorerState => portfolioSiteExplorerState.isSidebarOpen
);

export const getHoveredSiteId = createSelector(
    [getPortfolioSiteExplorerState],
    portfolioSiteExplorerState => portfolioSiteExplorerState.hoveredSiteId
);

export const getSelectedSiteId = createSelector(
    [getPortfolioSiteExplorerState],
    portfolioSiteExplorerState => portfolioSiteExplorerState.selectedSiteId
);

export const getSelectedMetric = createSelector(
    [getPortfolioSiteExplorerState],
    portfolioSiteExplorerState => portfolioSiteExplorerState.selectedMetric
);
